import { Box, Button, Dialog, DialogContent, IconButton, makeStyles, Typography } from "@material-ui/core";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

import { buttonBaseStyle, buttonSizeStyles, buttonToneStyles } from "@/buttonStyles";
import theme from "@/theme";

import SecondOpinionHeroImage from "@assets/image/second_opinion_popup.png";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: 8,
    overflow: "visible",
    backgroundColor: "#2F3168",
  },
  dialogContent: {
    padding: 0,
    position: "relative",
    overflow: "visible",
    "&.MuiDialogContent-root:first-child": {
      paddingTop: 0,
    },
  },
  contentShell: {
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#2F3168",
  },
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
    transform: "translate(50%, -50%)",
    padding: 10,
    zIndex: 2,
    color: theme.palette.common.white,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.55)",
    },
  },
  heroImage: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  body: {
    padding: theme.spacing(2, 2.5, 2.5),
    color: theme.palette.common.white,
  },
  limitedBadge: {
    backgroundColor: theme.palette.common.white,
    color: "#2F3168",
    borderRadius: 999,
    textAlign: "center",
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1,
    padding: theme.spacing(0.5, 1.5),
  },
  title: {
    marginTop: theme.spacing(1),
    textAlign: "center",
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.5,
  },
  description: {
    marginTop: theme.spacing(1.5),
    textAlign: "center",
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.8,
  },
  pointsBox: {
    margin: theme.spacing(1.5, "auto", 0),
    width: "fit-content",
    border: "2px solid rgba(255, 255, 255, 0.7)",
    borderRadius: 8,
    padding: theme.spacing(2),
  },
  pointRow: {
    display: "flex",
    alignItems: "center",
    "&:not(:first-child)": {
      marginTop: theme.spacing(1.5),
    },
  },
  checkMarkIcon: {
    color: theme.palette.warning.main,
    fontSize: 20,
    marginRight: theme.spacing(1),
  },
  pointText: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1,
  },
  ctaButton: {
    marginTop: theme.spacing(1.5),
    width: "100%",
    "&&&": { ...buttonBaseStyle, ...buttonSizeStyles.L, ...buttonToneStyles.trust },
  },
}));

type Props = {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
};

export const SecondOpinionStartupModal: React.FC<Props> = ({ open, onClose, onApply }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ className: classes.dialogPaper }}>
      <DialogContent className={classes.dialogContent}>
        <IconButton className={classes.closeButton} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>

        <Box className={classes.contentShell}>
          <img src={SecondOpinionHeroImage} alt="セカンドオピニオン" className={classes.heroImage} />

          <Box className={classes.body}>
            <Typography className={classes.limitedBadge}>不動産会社じゃないからこそ安心！</Typography>
            <Typography className={classes.title}>
              アプリ運営事務局による
              <br />
              無料のセカンドオピニオン
            </Typography>
            <Typography className={classes.description}>
              今、「ちょっと不安がある」「背中を押されすぎている気がする」そんな感覚があるなら、
              <br />
              一度セカンドオピニオンをご利用ください。
            </Typography>

            <Box className={classes.pointsBox}>
              <Box className={classes.pointRow}>
                <CheckBoxOutlinedIcon className={classes.checkMarkIcon} />
                <Typography className={classes.pointText}>失敗しない始め方を知りたい</Typography>
              </Box>
              <Box className={classes.pointRow}>
                <CheckBoxOutlinedIcon className={classes.checkMarkIcon} />
                <Typography className={classes.pointText}>購入検討物件の妥当性が不安</Typography>
              </Box>
              <Box className={classes.pointRow}>
                <CheckBoxOutlinedIcon className={classes.checkMarkIcon} />
                <Typography className={classes.pointText}>一番高く売却を行いたい</Typography>
              </Box>
              <Box className={classes.pointRow}>
                <CheckBoxOutlinedIcon className={classes.checkMarkIcon} />
                <Typography className={classes.pointText}>最適なプランナーの紹介</Typography>
              </Box>
            </Box>

            <Button className={classes.ctaButton} onClick={onApply}>
              お申し込みはこちらから
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SecondOpinionStartupModal;
